@if (typingAdmins.length > 0) {
  <div margin-tb-small>
    <rt-note-typing-indicator-message [typingAdmins]="typingAdmins">
    </rt-note-typing-indicator-message>
  </div>
}

@for (note of sortedNotes; track trackByNote($index, note)) {
  <rt-note-item
    #noteRef
    [attr.data-id]="note.id"
    [note]="note"
    [allNotesFlat]="allNotesFlat"
    [privateContext]="note.private!"
    [editing]="notesBeingEdited.includes(note.id!)"
    [replying]="notesBeingRepliedTo.includes(note.id!)"
    [cachedReply]="cachedReply!"
    [currentAdmin]="currentAdmin"
    [currentlyTypedNotes]="currentlyTypedNotes"
    [noteSaveLoading]="notesBeingSaved"
    [notesDeleteLoading]="notesBeingDeleted"
    [noteAttachmentLoading]="noteAttachmentsBeingUploaded"
    [canDeleteAttachments]="canDeleteAttachments"
    [canHighLevelDataAccess]="canHighLevelDataAccess"
    [isVisibilityEnabled]="isVisibilityEnabled"
    [notesBeingEdited]="notesBeingEdited"
    [notesBeingRepliedTo]="notesBeingRepliedTo"
    [adminsList]="adminsList"
    [disallowedAdminsList]="disallowedAdminsList"
    [attachmentsTemp]="noteAttachmentsTemp"
    [isReadOnly]="isReadOnly"
    [withNewStyling]="withNewStyling"
    (replyTypingStart)="replyTypingStart.emit($event)"
    (replyTypingFinish)="replyTypingFinish.emit()"
    (replyChanges)="setCachedReply($event)"
    (noteDiscardClick)="noteDiscardClick.emit($event)"
    (noteSaveClick)="noteSaveClick.emit($event)"
    (noteChecklistClick)="noteChecklistClick.emit($event)"
    (noteDeleteClick)="noteDeleteClick.emit($event)"
    (notePinClick)="notePinClick.emit($event)"
    (noteUnpinClick)="noteUnpinClick.emit($event)"
    (noteEditClick)="noteEditClick.emit($event)"
    (noteReplyClick)="noteReplyClick.emit($event)"
    (uploadAttachmentClick)="uploadAttachmentClick.emit($event)"
    (deleteAttachmentClick)="deleteAttachmentClick.emit($event)"
  >
  </rt-note-item>
}
